import { RightOutlined } from '@ant-design/icons';
import { Button, ButtonProps } from 'antd';
import * as React from 'react';

interface SaveAndContinueButtonState { }

interface SaveAndContinueButtonProps extends ButtonProps {
  title?: string;
  submitting?: boolean;
}

class SaveAndContinueButton extends React.Component<SaveAndContinueButtonProps, SaveAndContinueButtonState> {
  constructor(props: SaveAndContinueButtonProps) {
    super(props);

    this.state = {};
  }

  render() {
    const htmlType = this.props.htmlType ? this.props.htmlType : 'submit'
    const buttonType = this.props.type ? this.props.type : 'primary'

    return (
      <Button
        {...this.props}
        htmlType={htmlType}
        type={buttonType}
        icon={<RightOutlined />}
        loading={this.props.submitting || this.props.loading} >
        {this.props.title ?? 'Save and Continue'}
      </Button>
    );
  }
}

export default SaveAndContinueButton;
